export default __webpack_public_path__ + "static/media/B1.ce350c7b.png";